import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
const QUESTION_KEY = 'goals'

const OPTIONS = [
  {
    value: 'Make more space',
    translationKey: 'pages.onboarding.goals.options.makeSpace',
  },
  {
    value: 'Clear my mind',
    translationKey: 'pages.onboarding.goals.options.clearMind',
  },
  {
    value: 'Prepare for a move',
    translationKey: 'pages.onboarding.goals.options.prepareMove',
  },
  {
    value: 'Build better habits',
    translationKey: 'pages.onboarding.goals.options.buildHabits',
  },
  {
    value: 'Redesign my space',
    translationKey: 'pages.onboarding.goals.options.redesignSpace',
  },
  {
    value: 'Just experimenting',
    translationKey: 'pages.onboarding.goals.options.experimenting',
  },
]

export default function GoalsPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  useEffect(() => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: 'REQUEST_ATT' }),
      )
    }
  }, [])

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the answer value from the form
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: "What's your main decluttering goal?",
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  // Transform options to the format expected by QuestionPage
  const buttons = OPTIONS.map((option) => ({
    text: t(option.translationKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.goals.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
